import React, { ReactNode } from 'react';
import Chevron from 'components/Chevron';
import { colors } from 'utils/constants';
import Link from 'next/link';

interface ITitleProps {
  icon?: string
  title: string
  badgeText?: string
  collapsible: boolean
  expanded: boolean
  setExpanded?: (expanded: boolean) => void
}

const Title = ({ icon, title, badgeText, collapsible, expanded, setExpanded }: ITitleProps) => (
  <div className="titleContainer fullWidth flexRow" onClick={() => setExpanded ? setExpanded(!expanded) : null}>
    <div className="flexRow">
      <img className="titleIcon" src={ icon }/>
      <h2 className="titleText">
        { title }
        { badgeText && (
          <span
            style={{
              fontWeight: 700,
              fontSize: '0.8em',
              backgroundColor: 'red',
              color: 'white',
              borderRadius: 5000,
              padding: '3px 10px',
              minWidth: 20,
              letterSpacing: 0,
              marginLeft: 10,
              whiteSpace: 'nowrap',
              textTransform: 'uppercase',
            }}
          >
            { badgeText }
          </span>
        )}
      </h2>
    </div>
    { collapsible ? (
      <Chevron
        direction="down"
        reversed={ expanded }
        style={ { color: colors.primaryBrandGray, fontSize: '1em', height: 'auto', width: '12px', marginRight: 0 } }
      />
    ) : (
      <Chevron
        direction="right"
        style={ { color: colors.primaryBrandGray, fontSize: '1em', height: 'auto', width: '9px', marginRight: 0 } }
      />
    ) }

    <style jsx>
      { `
      .titleContainer {
        justify-content: space-between;
        padding: 1.5em 1em;
        cursor: pointer;
      }
       
      .titleIcon {
        width: 20px;
        max-height: 20px;
        margin-right: 1.3em;
      }
       
      .titleText {
        text-transform: none;
        letter-spacing: 0;
        font-size: 1.3em;
        margin-top: 0;
        text-align: left;
      }
      ` }
    </style>
  </div>
);

interface IAccountBoxProps {
  id?: string;
  additionalClassName?: string;
  icon?: string;
  title?: string;
  badgeText?: string;
  collapsible: boolean;
  expanded: boolean;
  setExpanded?: (expanded: boolean) => void;
  children?: ReactNode;
  href?: string;
  onClick?: () => void;
  newTab?: boolean;
}

export const AccountBox = ({
  id,
  additionalClassName,
  title,
  badgeText,
  icon,
  collapsible,
  expanded,
  setExpanded,
  onClick,
  href,
  children,
  newTab,
}: IAccountBoxProps) => {
  return (
    <div
      id={id}
      className={`accountBox ${
        additionalClassName ? additionalClassName : ''
      } fullWidth flexCentered`}
    >
      {title &&
        (href ? (
          newTab ? (
            <div className="fullWidth">
              <a
                href={href}
                target="_blank"
              >
                <Title
                  icon={icon}
                  title={title}
                  badgeText={badgeText}
                  collapsible={collapsible}
                  expanded={expanded}
                  setExpanded={setExpanded}
                />
              </a>
            </div>
          ) : (
            <Link href={href}>
              <div className="fullWidth">
                <Title
                  icon={icon}
                  title={title}
                  badgeText={badgeText}
                  collapsible={collapsible}
                  expanded={expanded}
                  setExpanded={setExpanded}
                />
              </div>
            </Link>
          )
        ) : (
          <div
            className="fullWidth"
            onClick={onClick}
          >
            <Title
              icon={icon}
              title={title}
              badgeText={badgeText}
              collapsible={collapsible}
              expanded={expanded}
              setExpanded={setExpanded}
            />
          </div>
        ))}

      {((collapsible && expanded) || !title) && (
        <div className="childrenContainer fullWidth flexCentered">
          {children}
        </div>
      )}

      <style jsx>
        {`
          .accountBox {
            max-width: 550px;
            border: 3px solid #ddd;
            border-radius: 5px;
            overflow: hidden;
          }

          .childrenContainer {
            padding: ${title ? '1em' : '2em'} 1em 2em;
          }
        `}
      </style>
    </div>
  );
};

export default AccountBox;
